<template>
  <div>
    <div class="card">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless pd-10px width-535">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ projetActuel
              ? $t('listeProjets.popUpAjoutProjet.edit')
              : $t('listeProjets.popUpAjoutProjet.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'addModeReglement.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns is-multiline">
          <b-field :label="$t('listeProjets.popUpAjoutProjet.libelle')"
                   class="obligatoire column is-6"
                   :class="agencesSelectionnees.length > 1 ? 'is-6' : 'is-12'">
            <b-input v-model="projet.libelle"></b-input>
          </b-field>
          <div class="column is-6" v-if="agencesSelectionnees.length > 1">
            <selection-agence v-model="projet.agenceId" obligatoire set-first-agence-find>
            </selection-agence>
          </div>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('addModeReglement.actions.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="saveProjet()">
                {{ projetActuel ? $t('general.button.edit') : $t('general.button.add') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererProjetTechnique from '@/services/logistique/projets/genererProjetTechnique';
import { create, update } from '@/api/logistique/projets';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import selectionAgence from '@/components/general/selectionAgence';
import validationGeneral from '@/services/validation/validation';
import messageSucces from '@/services/general/messageSucces';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_ajoutProjet',
  props: {
    projetActuel: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      projet: genererProjetTechnique(),
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  components: {
    errorMsgComponent,
    selectionAgence,
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
  },
  methods: {
    async saveProjet() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (!this.projetActuel) {
          if (!this.projet.agenceId) this.projet.agenceId = this.agencesSelectionnees[0].agenceId;
          await create(this.projet);
          messageSucces(this.$i18n.t('listeProjets.messages.success.createProjet'));
        } else {
          await update(this.projet);
          messageSucces(this.$i18n.t('listeProjets.messages.success.updateProjet'));
        }
        loadingComponent.close();
        this.$parent.close();
        this.$emit('refresh');
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    if (this.projetActuel) {
      this.projet = cloneDeep(this.projetActuel);
    }
  },
};
</script>
